import { KeyRound } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription } from '@/Domain/components/Shared/Alert/Alert';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { Spinner } from '@/Domain/components/Shared/Spinner';
import { usePasskeyLogin } from '@/Domain/hooks/Auth/usePasskeyLogin.hook';

export const PasskeyLoginButton = () => {
  const { t } = useTranslation('login');
  const { isSupported, signInWithPasskey, isPending, errorMessage } = usePasskeyLogin();

  if (!isSupported) {
    return null;
  }

  return (
    <>
      <Button
        type="button"
        variant="secondary"
        size="lg"
        onClick={signInWithPasskey}
        disabled={isPending}
        className="w-full gap-3 font-medium"
        data-testid="login-passkey"
      >
        {isPending ? <Spinner /> : <KeyRound className="h-5 w-5" />}
        <span>{t('passkey.button')}</span>
      </Button>
      {errorMessage && (
        <Alert
          variant="destructive"
          data-testid="login-passkey-error"
          className="animate-in fade-in duration-200"
        >
          <AlertDescription>{errorMessage}</AlertDescription>
        </Alert>
      )}
    </>
  );
};
